/**
 * Cart Drawer Upsell — quick add
 * Handles clicks on ".cart-upsell__add[data-variant-id]" buttons rendered by
 * snippets/cart-drawer-upsell.liquid. Adds the variant to the cart via the
 * Ajax Cart API, then refreshes the cart drawer and header cart bubble in
 * place (no page reload) and opens the drawer.
 */
(function () {
  function getCartDrawerRoot() {
    return document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
  }

  function openDrawer(root) {
    if (!root) return;
    if (typeof root.open === 'function') {
      // Dawn's <cart-drawer> custom element exposes an open() method
      root.open();
      return;
    }
    // Fallback: toggle the classes Dawn uses to show the drawer
    root.classList.remove('is-empty');
    root.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function swapSectionHTML(sectionId, targetSelector, html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newTarget = doc.querySelector(targetSelector);
    var currentTarget = document.querySelector(targetSelector);
    if (newTarget && currentTarget) {
      currentTarget.innerHTML = newTarget.innerHTML;
    }
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  function announce(message) {
    var status = document.getElementById('CartDrawer-UpsellStatus');
    if (status) status.textContent = message;
  }

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    var productTitle = button.getAttribute('data-product-title') || '';
    if (!variantId) return;

    setButtonLoading(button, true);

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          // Shopify returns an error payload (e.g. sold out) with a "status" key
          announce(data.description || 'Could not add that item to your cart.');
          setButtonLoading(button, false);
          return;
        }

        if (data.sections && data.sections['cart-drawer']) {
          swapSectionHTML('cart-drawer', '#CartDrawer', data.sections['cart-drawer']);
        }
        if (data.sections && data.sections['cart-icon-bubble']) {
          swapSectionHTML('cart-icon-bubble', '#cart-icon-bubble', data.sections['cart-icon-bubble']);
        }

        announce(productTitle + ' added to your cart.');
        openDrawer(getCartDrawerRoot());

        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'cart-drawer-upsell' } })
        );
      })
      .catch(function () {
        announce('Something went wrong adding that item. Please try again.');
        setButtonLoading(button, false);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-upsell__add[data-variant-id]');
    if (!button) return;
    event.preventDefault();
    quickAdd(button);
  });
})();